<!-- eslint-disable no-unused-expressions -->
<template>
  <div class="login">
    <div class="chanpin_box">
      <img class="logo" src="@/assets/img/logo.png" alt="" />
      <div class="chanpin_name">
        <p>UangMu</p>
        <span>Datan dan pinjam uang</span>
      </div>
      <img class="login_icon" src="@/assets/img/login_icon.png" alt="" />
    </div>
    <div class="chanpin_info">
      <div class="title">Pinjaman Hingga</div>
      <div class="jine">Rp 6.000.000</div>
      <div class="youdian">
        <div class="left">
          <div class="top">Durasi Pinjaman</div>
          <div class="bottom">90 Hari</div>
        </div>
        <div class="right">
          <div class="top">Bunga Pinjaman</div>
          <div class="bottom">0.25%</div>
        </div>
      </div>
    </div>
    <button @click="toLogin">Ajukan Sekarang</button>

    <div class="advertising" v-show="advertisingShow">
      <img class="advertising_close" src="@/assets/img/advertising_close.png" @click="advertisingShow = false" />
      <div class="advertising_content">
        <img class="advertising_content_logo" :src="home1_yinliu_logo" />
        <div class="advertising_content_name">
          <span>{{ productName }} - Pinjaman Online OJK</span>
          <span>App Store</span>
        </div>
        <a class="advertising_download" :href="downloadUrl">
          Download Aplikasi
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import trafficConfig from '@/mixins/trafficConfig'
export default {
  mixins: [trafficConfig],
  data () {
    return {
      advertisingShow: true
    }
  },
  methods: {
    toLogin () {
      // eslint-disable-next-line no-unused-expressions
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'
        n.queue = []; t = b.createElement(e); t.async = !0
        t.src = v; s = b.getElementsByTagName(e)[0]
        s.parentNode.insertBefore(t, s)
      }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js'))
      // eslint-disable-next-line no-undef
      fbq('init', '895520539163270')
      // eslint-disable-next-line no-undef
      fbq('track', 'ViewContent')
      this.$router.push('/login1')
    }
  }
}
</script>

<style scoped lang='less'>
.login {
  min-height: 100vh;
  background: url("~@/assets/img/login_bg.png");
  background-size: 100% 100%;

  .chanpin_box {
    display: flex;
    align-items: center;
    padding-top: 80px;

    .logo {
      width: 112px;
      height: 112px;
      margin-left: 24px;
      margin-right: 20px;
    }

    .chanpin_name {
      font-size: 32px;

      p {
        font-weight: bold;
        font-size: 32px;
        color: #333333;
      }

      span {
        font-weight: 500;
        font-size: 24px;
        color: #ff7d17;
      }
    }

    .login_icon {
      position: absolute;
      right: 0;
      top: 0;
      width: 322px;
    }
  }

  .chanpin_info {
    margin: 0 auto;
    margin-top: 140px;
    width: 686px;
    height: 380px;
    background: #ffffff;
    box-shadow: 0px 0px 36px 0px rgba(2, 16, 89, 0.08);
    border-radius: 32px 32px 32px 32px;

    .title {
      padding-top: 32px;
      font-weight: 500;
      font-size: 32px;
      color: #aaaaaa;
      text-align: center;
      line-height: 48px;
    }

    .jine {
      font-weight: bold;
      font-size: 60px;
      color: #07975f;
      line-height: 90px;
      text-align: center;
      margin-bottom: 64px;
    }

    .youdian {
      display: flex;
      align-items: center;
      justify-content: space-around;
    }

    .left,
    .right {
      .top {
        font-weight: 500;
        font-size: 28px;
        color: #aaaaaa;
        line-height: 42px;
        text-align: center;
      }

      .bottom {
        font-weight: bold;
        font-size: 48px;
        color: #07975f;
        line-height: 72px;
        text-align: center;
      }
    }
  }

  button {
    margin: 0 auto;
    margin-top: 386px;
    width: 582px;
    height: 80px;
    background: #07975f;
    border-radius: 16px 16px 16px 16px;
    font-weight: 500;
    font-size: 32px;
    color: #ffffff;
  }

  .advertising {
    height: 90px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    .advertising_close {
      position: absolute;
      top: 0;
      width: 30px;
      height: 30px;
    }

    .advertising_content {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);

      .advertising_content_logo {
        width: 70px;
        height: 70px;
        border-radius: 10px;
        margin-left: 20px;
        margin-right: 10px;
      }

      .advertising_content_name {
        display: flex;
        flex-direction: column;
        color: #fff;

        span:first-child {
          font-size: 22px;
          font-weight: 600;
          margin-bottom: 6px;
        }

        span:last-child {
          font-size: 20px;
        }
      }

      .advertising_download {
        padding: 0 20px;
        background: #58a9ca;
        font-size: 24px;
        border-radius: 40px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        color: #fff;
        margin-left: auto;
        margin-right: 30px;
      }
    }

  }
}
</style>
